import { MouseClickRightSvg } from "@lhd/assets";
import { COLUMN_TYPE_SETTING, DATE_TIME_FORMAT } from "@lhd/constants";
import { checkInvalidValue } from "@lhd/features/Workers/WorkerCreate/WorkerCreateSheet/utility";
import { BankInfo, CompanyLocation, IOptions } from "@lhd/types";
import { formatToJPDate, toDatePickerApiDate } from "@lhd/utility";
import dayjs from "dayjs";
import { cloneDeep, get, isUndefined, omit, split, toString } from "lodash";
import { COMPANY_DETAIL_TABS } from "../CustomerDetail/hook";
import {
  CONTRACT_STATUS_OPTIONS,
  CONTRACT_TYPE_OPTIONS,
} from "../NewCustomerControl/utils";
import { IData } from "./hook";

export const clientSheetTabParams = {
  [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: "save_tab1",
  [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: "save_tab2",
  [COMPANY_DETAIL_TABS.CONTRACT.key]: "save_tab3",
};

export const fieldsDefined = {
  //commons fields
  co_number: "co_number",
  foundation_date: "foundation_date",
  contract_date: "contract_date",
  establishment_date: "establishment_date",
  contract_cancellation_date: "contract_cancellation_date",

  //field tab
  client_info: "client_info",
  client_name: "client_name",
  client_leadership: "client_leadership",
  client_location: "client_location",
  client_location_head_office: "head_office",
  client_location_branch_office: "branch_office",
  client_location_sales_office: "sales_office",
  client_phone_number: "client_phone_number",
  client_phone_number_head_office: "phone_number_head_office",
  client_phone_number_branch_office: "phone_number_branch_office",
  client_phone_number_sales_office: "phone_number_sales_office",
  client_invoice: "client_invoice",
  client_bank_info: "client_bank_info",
  client_registration_info: "client_registration_info",
  client_accounting_period: "client_accounting_period",
  client_contract_status: "client_contract_status",
  client_contract_type: "client_contract_type",

  //table 1 tab1
  client_name_name: "client_name.name",
  client_name_company_type: "client_name.company_type",
  client_name_show_company_type: "client_name.show_company_type",
  client_name_start_date: "client_name.start_date",
  client_name_registration_date: "client_name.registration_date",
  //table2 tab1
  client_leadership_position: "client_leadership.position",
  client_leadership_worker_id: "client_leadership.worker_id",
  client_leadership_reason: "client_leadership.reason",
  client_leadership_start_date: "client_leadership.start_date",
  client_leadership_effective_end_date: "client_leadership.effective_end_date",
  client_leadership_end_date: "client_leadership.end_date",
  //table3 tab1
  client_location_head_office_location_name: "head_office.location_name",
  client_location_head_office_zipcode: "head_office.zipcode",
  client_location_head_office_prefecture_id: "head_office.prefecture_id",
  client_location_head_office_address: "head_office.address",
  client_location_head_office_apartment: "head_office.apartment",
  //table3 tab1
  client_location_branch_office_location_name: "branch_office.location_name",
  client_location_branch_office_zipcode: "branch_office.zipcode",
  client_location_branch_office_prefecture_id: "branch_office.prefecture_id",
  client_location_branch_office_address: "branch_office.address",
  client_location_branch_office_apartment: "branch_office.apartment",
  //table3 tab1
  client_location_sales_office_location_name: "sales_office.location_name",
  client_location_sales_office_zipcode: "sales_office.zipcode",
  client_location_sales_office_prefecture_id: "sales_office.prefecture_id",
  client_location_sales_office_address: "sales_office.address",
  client_location_sales_office_apartment: "sales_office.apartment",
  //commons tab2
  station_id: "station_id",
  //table1 tab2
  client_phone_number_head_office_location_name:
    "phone_number_head_office.location_name",
  client_phone_number_head_office_fax: "phone_number_head_office.fax",
  client_phone_number_head_office_usage_memo:
    "phone_number_head_office.usage_memo",
  client_phone_number_head_office_contract_memo:
    "phone_number_head_office.contract_memo",
  client_phone_number_branch_office_location_name:
    "phone_number_branch_office.location_name",
  client_phone_number_branch_office_fax: "phone_number_branch_office.fax",
  client_phone_number_branch_office_usage_memo:
    "phone_number_branch_office.usage_memo",
  client_phone_number_branch_office_contract_memo:
    "phone_number_branch_office.contract_memo",
  client_phone_number_sales_office_location_name:
    "phone_number_sales_office.location_name",
  client_phone_number_sales_office_fax: "phone_number_sales_office.fax",
  client_phone_number_sales_office_usage_memo:
    "phone_number_sales_office.usage_memo",
  client_phone_number_sales_office_contract_memo:
    "phone_number_sales_office.contract_memo",
  //table2 tab2
  client_invoice_invoice_no: "client_invoice.invoice_no",
  //table3 tab2
  client_bank_info_bank_name: "client_bank_info.bank_name",
  client_bank_info_branch_name: "client_bank_info.branch_name",
  client_bank_info_bank_type: "client_bank_info.bank_type",
  client_bank_info_bank_number: "client_bank_info.bank_number",
  client_bank_info_trade_name: "client_bank_info.trade_name",
  client_bank_info_address: "client_bank_info.address",
  //table4 tab2
  client_registration_info_registration_name:
    "client_registration_info.registration_name",
  client_registration_info_registration_code:
    "client_registration_info.registration_code",
  client_registration_info_branch_code: "client_registration_info.branch_code",
  client_registration_info_involved_professional:
    "client_registration_info.involved_professional",
  client_registration_info_note: "client_registration_info.note",

  //tab3 table 1
  client_contract_type_category: "client_contract_type.category",
  client_contract_type_customer_number: "client_contract_type.customer_number",
  client_contract_type_start_date: "client_contract_type.start_date",
  client_contract_type_end_date: "client_contract_type.end_date",
  client_contract_type_memo: "client_contract_type.memo",
  //tab3 table 2
  client_contract_status_status: "client_contract_status.status",
  client_contract_status_staff_in_charge:
    "client_contract_status.staff_in_charge",
  client_contract_status_start_date: "client_contract_status.start_date",
  client_contract_status_end_date: "client_contract_status.end_date",
  client_contract_status_memo: "client_contract_status.memo",
} as const;

export const commonColumns = (size?: any) => [
  {
    columnId: "index",
    label: "",
    type: "text",
    width: 65,
    editable: false,
    icon: <></>,
    colspan: 1,
  },
  {
    label: "企業名 (事業所名)",
    columnId: fieldsDefined.client_name_name,
    width: 180,
    type: "text",
    icon: <></>,
    colspan: 1,
  },
  {
    label: "会社形態",
    columnId: fieldsDefined.client_name_company_type,
    width: 140,
    type: "text",
    icon: <></>,
    colspan: 1,
  },
  {
    label: "前後",
    columnId: fieldsDefined.client_name_show_company_type,
    width: 140,
    type: "text",
    icon: <MouseClickRightSvg size={size} />,
    colspan: 1,
  },
  {
    label: "開始日",
    columnId: fieldsDefined.client_name_start_date,
    width: 140,
    type: "dateTimeCustom",
    icon: <></>,
    colspan: 1,
  },
];

export const allColumns = (size?: any) => {
  return {
    [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: [
      ...commonColumns(size),
      {
        label: "記録日",
        columnId: fieldsDefined.client_name_registration_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        colspan: 1,
        groupHeaderLabel: "事業情報",
        filterKey: fieldsDefined.client_name,
      },
      //table 1
      {
        label: "法人番号",
        columnId: fieldsDefined.co_number,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 5,
        groupHeaderLabel: "固定情報",
        filterKey: fieldsDefined.client_info,
      },
      {
        label: "創立日",
        columnId: fieldsDefined.foundation_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_info,
      },
      {
        label: "設立日",
        columnId: fieldsDefined.establishment_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_info,
      },
      {
        label: "Biz契約日",
        columnId: fieldsDefined.contract_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_info,
      },
      {
        label: "Biz解約日",
        columnId: fieldsDefined.contract_cancellation_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_info,
      },
      //table 2
      {
        label: "役員種類",
        columnId: fieldsDefined.client_leadership_position,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 6,
        groupHeaderLabel: "役員",
        filterKey: fieldsDefined.client_leadership,
      },
      {
        label: "役員名",
        columnId: fieldsDefined.client_leadership_worker_id,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        filterKey: fieldsDefined.client_leadership,
      },
      {
        label: "発生事由",
        columnId: fieldsDefined.client_leadership_reason,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_leadership,
      },
      {
        label: "就任日",
        columnId: fieldsDefined.client_leadership_start_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_leadership,
      },
      {
        label: "満了日",
        columnId: fieldsDefined.client_leadership_effective_end_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_leadership,
      },
      {
        label: "退任日",
        columnId: fieldsDefined.client_leadership_end_date,
        width: 160,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_leadership,
      },
      //table 3
      {
        label: "本支店名",
        columnId: fieldsDefined.client_location_head_office_location_name,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 5,
        groupHeaderLabel: "本店",
        filterKey: fieldsDefined.client_location_head_office,
      },
      {
        label: "〒",
        columnId: fieldsDefined.client_location_head_office_zipcode,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_head_office,
      },
      {
        label: "都道府県",
        columnId: fieldsDefined.client_location_head_office_prefecture_id,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        filterKey: fieldsDefined.client_location_head_office,
      },
      {
        label: "住所 (市区町村・番地)",
        columnId: fieldsDefined.client_location_head_office_address,
        width: 192,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_head_office,
      },
      {
        label: "建物名・部屋番号",
        columnId: fieldsDefined.client_location_head_office_apartment,
        width: 170,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_head_office,
      },
      {
        label: "本支店名",
        columnId: fieldsDefined.client_location_branch_office_location_name,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 5,
        groupHeaderLabel: "支店",
        filterKey: fieldsDefined.client_location_branch_office,
      },
      {
        label: "〒",
        columnId: fieldsDefined.client_location_branch_office_zipcode,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_branch_office,
      },
      {
        label: "都道府県",
        columnId: fieldsDefined.client_location_branch_office_prefecture_id,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        filterKey: fieldsDefined.client_location_branch_office,
      },
      {
        label: "住所 (市区町村・番地)",
        columnId: fieldsDefined.client_location_branch_office_address,
        width: 192,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_branch_office,
      },
      {
        label: "建物名・部屋番号",
        columnId: fieldsDefined.client_location_branch_office_apartment,
        width: 170,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_branch_office,
      },
      {
        label: "本支店名",
        columnId: fieldsDefined.client_location_sales_office_location_name,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 5,
        groupHeaderLabel: "営業所",
        filterKey: fieldsDefined.client_location_sales_office,
      },
      {
        label: "〒",
        columnId: fieldsDefined.client_location_sales_office_zipcode,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_sales_office,
      },
      {
        label: "都道府県",
        columnId: fieldsDefined.client_location_sales_office_prefecture_id,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        filterKey: fieldsDefined.client_location_sales_office,
      },
      {
        label: "住所 (市区町村・番地)",
        columnId: fieldsDefined.client_location_sales_office_address,
        width: 192,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_sales_office,
      },
      {
        label: "建物名・部屋番号",
        columnId: fieldsDefined.client_location_sales_office_apartment,
        width: 170,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_location_sales_office,
      },
    ],
    [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: [
      ...commonColumns(size),
      {
        label: "ステーションID",
        columnId: fieldsDefined.station_id,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 1,
        groupHeaderLabel: "ステーションID",
        filterKey: fieldsDefined.station_id,
      },
      //table 1
      {
        label: "本支店名選択",
        columnId: fieldsDefined.client_phone_number_head_office_location_name,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        colspan: 4,
        groupHeaderLabel: "本店",
        filterKey: fieldsDefined.client_phone_number_head_office,
      },
      {
        label: "電話FAX番号",
        columnId: fieldsDefined.client_phone_number_head_office_fax,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_head_office,
      },
      {
        label: "用途MEMO",
        columnId: fieldsDefined.client_phone_number_head_office_usage_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_head_office,
      },
      {
        label: "契約MEMO",
        columnId: fieldsDefined.client_phone_number_head_office_contract_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_head_office,
      },
      {
        label: "本支店名選択",
        columnId: fieldsDefined.client_phone_number_branch_office_location_name,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        colspan: 4,
        groupHeaderLabel: "支店",
        filterKey: fieldsDefined.client_phone_number_branch_office,
      },
      {
        label: "電話FAX番号",
        columnId: fieldsDefined.client_phone_number_branch_office_fax,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_branch_office,
      },
      {
        label: "用途MEMO",
        columnId: fieldsDefined.client_phone_number_branch_office_usage_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_branch_office,
      },
      {
        label: "契約MEMO",
        columnId: fieldsDefined.client_phone_number_branch_office_contract_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_branch_office,
      },
      {
        label: "本支店名選択",
        columnId: fieldsDefined.client_phone_number_sales_office_location_name,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        colspan: 4,
        groupHeaderLabel: "営業所",
        filterKey: fieldsDefined.client_phone_number_sales_office,
      },
      {
        label: "電話FAX番号",
        columnId: fieldsDefined.client_phone_number_sales_office_fax,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_sales_office,
      },
      {
        label: "用途MEMO",
        columnId: fieldsDefined.client_phone_number_sales_office_usage_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_sales_office,
      },
      {
        label: "契約MEMO",
        columnId: fieldsDefined.client_phone_number_sales_office_contract_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_phone_number_sales_office,
      },

      //table số 2
      {
        label: "インボイス",
        columnId: fieldsDefined.client_invoice_invoice_no,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 1,
        groupHeaderLabel: "インボイス",
        filterKey: fieldsDefined.client_invoice,
      },
      //table 3
      {
        label: "銀行名",
        columnId: fieldsDefined.client_bank_info_bank_name,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 6,
        groupHeaderLabel: "口座情報",
        filterKey: fieldsDefined.client_bank_info,
      },
      {
        label: "支店名",
        columnId: fieldsDefined.client_bank_info_branch_name,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_bank_info,
      },
      {
        label: "口座種別",
        columnId: fieldsDefined.client_bank_info_bank_type,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        filterKey: fieldsDefined.client_bank_info,
      },
      {
        label: "口座番号",
        columnId: fieldsDefined.client_bank_info_bank_number,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_bank_info,
      },
      {
        label: "口座名義 (カナ)",
        columnId: fieldsDefined.client_bank_info_trade_name,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_bank_info,
      },
      {
        label: "口座名義 (漢字)",
        columnId: fieldsDefined.client_bank_info_address,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_bank_info,
      },
      //table 4
      {
        label: "種類",
        columnId: fieldsDefined.client_registration_info_registration_name,
        width: 160,
        type: "text",
        icon: <></>,
        colspan: 5,
        groupHeaderLabel: "関与士業　　※「会計期」～「事業の種類」は非表示",
        filterKey: fieldsDefined.client_registration_info,
      },
      {
        label: "事業/店舗/ID",
        columnId: fieldsDefined.client_registration_info_registration_code,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_registration_info,
      },
      {
        label: "枝番号",
        columnId: fieldsDefined.client_registration_info_branch_code,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_registration_info,
      },
      {
        label: "関与士業",
        columnId: fieldsDefined.client_registration_info_involved_professional,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_registration_info,
      },
      {
        label: "備考MEMO",
        columnId: fieldsDefined.client_registration_info_note,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_registration_info,
      },
    ],
    [COMPANY_DETAIL_TABS.CONTRACT.key]: [
      ...commonColumns(size),
      {
        label: "契約種別（複数選択可)",
        columnId: fieldsDefined.client_contract_type_category,
        width: 220,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        colspan: 5,
        groupHeaderLabel: "契約種別（カテゴリー）・取引先番号",
        filterKey: fieldsDefined.client_contract_type,
      },
      {
        label: "取引先番号",
        columnId: fieldsDefined.client_contract_type_customer_number,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_type,
      },
      {
        label: "取引先番号 開始日(アップデート日)",
        columnId: fieldsDefined.client_contract_type_start_date,
        width: 210,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_type,
      },
      {
        label: "終了日（変更・満了日)",
        columnId: fieldsDefined.client_contract_type_end_date,
        width: 190,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_type,
      },
      {
        label: "取引MEMO",
        columnId: fieldsDefined.client_contract_type_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_type,
      },
      //table 2
      {
        label: "取引ステータス",
        columnId: fieldsDefined.client_contract_status_status,
        width: 160,
        type: "text",
        icon: <MouseClickRightSvg size={size} />,
        colspan: 5,
        groupHeaderLabel: "取引状況（ステータス）",
        filterKey: fieldsDefined.client_contract_status,
      },
      {
        label: "担当スタッフ",
        columnId: fieldsDefined.client_contract_status_staff_in_charge,
        width: 160,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_status,
      },
      {
        label: "開始日(アップデート日)",
        columnId: fieldsDefined.client_contract_status_start_date,
        width: 200,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_status,
      },
      {
        label: "終了日(変更・満了日)",
        columnId: fieldsDefined.client_contract_status_end_date,
        width: 190,
        type: "dateTimeCustom",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_status,
      },
      {
        label: "取引MEMO",
        columnId: fieldsDefined.client_contract_status_memo,
        width: 200,
        type: "text",
        icon: <></>,
        filterKey: fieldsDefined.client_contract_status,
      },
    ],
  };
};

export const REQUIRED_FIELDS = {
  [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: [
    fieldsDefined.client_name_name,
    fieldsDefined.client_name_company_type,
    fieldsDefined.client_name_show_company_type,
    fieldsDefined.client_name_start_date,
  ],
  [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: [
    fieldsDefined.client_name_name,
    fieldsDefined.client_name_company_type,
    fieldsDefined.client_name_show_company_type,
    fieldsDefined.client_name_start_date,
  ],
  [COMPANY_DETAIL_TABS.CONTRACT.key]: [
    fieldsDefined.client_name_name,
    fieldsDefined.client_name_company_type,
    fieldsDefined.client_name_show_company_type,
    fieldsDefined.client_name_start_date,
    fieldsDefined.client_contract_type_category,
    fieldsDefined.client_contract_type_customer_number,
    fieldsDefined.client_contract_type_start_date,
    fieldsDefined.client_contract_status_status,
  ],
};
export const DATE_FIELDS = {
  [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: [
    fieldsDefined.client_name_start_date,
    fieldsDefined.client_name_registration_date,
    fieldsDefined.contract_date,
    fieldsDefined.foundation_date,
    fieldsDefined.establishment_date,
    fieldsDefined.contract_cancellation_date,
    fieldsDefined.client_leadership_start_date,
    fieldsDefined.client_leadership_effective_end_date,
    fieldsDefined.client_leadership_end_date,
  ],
  [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: [
    fieldsDefined.client_name_start_date,
    fieldsDefined.client_name_registration_date,
  ],
  [COMPANY_DETAIL_TABS.CONTRACT.key]: [
    fieldsDefined.client_name_start_date,
    fieldsDefined.client_name_registration_date,
    fieldsDefined.client_contract_type_start_date,
    fieldsDefined.client_contract_type_end_date,
    fieldsDefined.client_contract_status_start_date,
    fieldsDefined.client_contract_status_end_date,
  ],
};

export const initialValues = {
  [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: {
    co_name: "",
    foundation_date: "",
    contract_date: "",
    establishment_date: "",
    contract_cancellation_date: "",
    [fieldsDefined.client_name]: {
      name: "",
      company_type: "",
      show_company_type: "",
      start_date: "",
      registration_date: "",
    },
    [fieldsDefined.client_leadership]: {
      position: "",
      worker_id: "",
      reason: "",
      start_date: "",
      end_date: "",
      effective_end_date: "",
    },
    [fieldsDefined.client_location_head_office]: {
      location_name: "",
      zipcode: "",
      prefecture_id: "",
      address: "",
      apartment: "",
    },
    [fieldsDefined.client_location_branch_office]: {
      location_name: "",
      zipcode: "",
      prefecture_id: "",
      address: "",
      apartment: "",
    },
    [fieldsDefined.client_location_sales_office]: {
      location_name: "",
      zipcode: "",
      prefecture_id: "",
      address: "",
      apartment: "",
    },
  },
  [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: {
    [fieldsDefined.client_name]: {
      name: "",
      company_type: "",
      show_company_type: "",
      start_date: "",
    },
    [fieldsDefined.station_id]: "",
    [fieldsDefined.client_phone_number_head_office]: {
      location_name: "",
      fax: "",
      usage_memo: "",
      contract_memo: "",
    },
    [fieldsDefined.client_phone_number_branch_office]: {
      location_name: "",
      fax: "",
      usage_memo: "",
      contract_memo: "",
    },
    [fieldsDefined.client_phone_number_sales_office]: {
      location_name: "",
      fax: "",
      usage_memo: "",
      contract_memo: "",
    },
    [fieldsDefined.client_invoice]: {
      invoice_no: "",
    },
    [fieldsDefined.client_bank_info]: {
      bank_name: "",
      branch_name: "",
      bank_type: "",
      bank_number: "",
      trade_name: "",
      address: "",
    },
    [fieldsDefined.client_registration_info]: {
      registration_name: "",
      registration_code: "",
      branch_code: "",
      involved_professional: "",
      note: "",
    },
  },
  [COMPANY_DETAIL_TABS.CONTRACT.key]: {
    [fieldsDefined.client_name]: {
      name: "",
      company_type: "",
      show_company_type: "",
      start_date: "",
    },
    [fieldsDefined.client_contract_type]: {
      category: "",
      customer_number: "",
      start_date: "",
      end_date: "",
      memo: "",
    },
    [fieldsDefined.client_contract_status]: {
      status: "",
      staff_in_charge: "",
      start_date: "",
      end_date: "",
      memo: "",
    },
  },
};

export const bankTypeOptions = [
  { label: "普通", value: "普通" },
  { label: "当座", value: "当座" },
];
export const companyTypeOptions = [
  { label: "前", value: "before" },
  { label: "後", value: "after" },
  { label: "無", value: "no_display" },
];
export const dateTypeColumns = [
  fieldsDefined.foundation_date,
  fieldsDefined.contract_date,
  fieldsDefined.establishment_date,
  fieldsDefined.contract_cancellation_date,
  fieldsDefined.client_name_start_date,
  fieldsDefined.client_name_registration_date,
  fieldsDefined.client_leadership_start_date,
  fieldsDefined.client_leadership_end_date,
  fieldsDefined.client_leadership_effective_end_date,
  fieldsDefined.client_contract_type_start_date,
  fieldsDefined.client_contract_type_end_date,
  fieldsDefined.client_contract_status_start_date,
  fieldsDefined.client_contract_status_end_date,
];
export const modalFields = [
  fieldsDefined.client_name_show_company_type,
  fieldsDefined.client_leadership_worker_id,
  fieldsDefined.client_location_head_office_prefecture_id,
  fieldsDefined.client_location_branch_office_prefecture_id,
  fieldsDefined.client_location_sales_office_prefecture_id,
  fieldsDefined.client_phone_number_head_office_location_name,
  fieldsDefined.client_phone_number_branch_office_location_name,
  fieldsDefined.client_phone_number_sales_office_location_name,
  fieldsDefined.client_bank_info_bank_type,
  fieldsDefined.client_contract_type_category,
  fieldsDefined.client_contract_status_status,
];
export const titleModalEnums = {
  [fieldsDefined.client_name_show_company_type]: "前後",
  [fieldsDefined.client_leadership_worker_id]: "役員名",
  [fieldsDefined.client_location_head_office_prefecture_id]: "都道府県",
  [fieldsDefined.client_location_branch_office_prefecture_id]: "都道府県",
  [fieldsDefined.client_location_sales_office_prefecture_id]: "都道府県",
  [fieldsDefined.client_phone_number_head_office_location_name]: "本支店名選択",
  [fieldsDefined.client_phone_number_branch_office_location_name]:
    "本支店名選択",
  [fieldsDefined.client_phone_number_sales_office_location_name]:
    "本支店名選択",
  [fieldsDefined.client_bank_info_bank_type]: "口座種別",
  [fieldsDefined.client_contract_type_category]: "契約種別",
  [fieldsDefined.client_contract_status_status]: "契約状況",
};
export const getTitleModal = (field: string) => {
  return titleModalEnums[field as keyof typeof titleModalEnums] || "";
};
export const getTypeByLabel = (
  label: string | null,
  options: IOptions,
  isMultiple?: boolean,
) => {
  if (!label) return null;
  if (isMultiple) {
    const labels = label.split(",").map((i) => i.trim());
    const values = options
      ?.filter((i) => labels.includes(i.label))
      .map((i) => i.value);
    return values;
  }
  return options?.find((i) => i?.label === label)?.value;
};
export const getOptionsByColumnId = (
  columnId: string,
  options: { columnId: string | string[]; options: IOptions }[],
): IOptions => {
  if (!columnId) return [];
  const found = options?.find(
    (i) => i.columnId === columnId || i.columnId?.includes(columnId),
  );
  return found ? found.options : [];
};

export const handleData = (data: IData[], dataTab: IData) => {
  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_) => dataTab),
  ];
};
export const columnTypeValueMap = Object.fromEntries(
  COLUMN_TYPE_SETTING.map((item) => [item.type, item.value]),
);
export const checkSheetInvalid = (
  data: IData,
  fields?: string[], // field validate
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      let value = null;
      const valueRaw = get(data, fieldItem);

      if (typeof valueRaw === "string") {
        value = valueRaw?.trim();
      } else {
        value = valueRaw;
      }

      if (!value || checkInvalidValue(value)) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      const valueRaw = get(data, keyItem);
      if (!valueRaw) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const convertDateToString = (date?: string | null) => {
  return date ? formatToJPDate(date) : null;
};

export const convertDataToItems = (
  data: IData[],
  tabParams: string,
  prefectureOptions: IOptions,
  workerOptions: IOptions,
  catalogOptions?: {
    contractStatusOptions?: any[];
    contractTypeOptions?: any[];
  },
) => {
  switch (tabParams) {
    case COMPANY_DETAIL_TABS.REGISTRATION_INFO.key:
      return data.map((item) => ({
        id: item.id ?? item?.client_id,
        co_number: item.co_number ?? "",
        foundation_date: convertDateToString(item.foundation_date),
        contract_date: convertDateToString(item.contract_date),
        establishment_date: convertDateToString(item.establishment_date),
        contract_cancellation_date: convertDateToString(
          item.contract_cancellation_date,
        ),
        [fieldsDefined.client_name]: {
          id: item.client_name?.id ?? "",
          name: item.client_name?.name ?? "",
          company_type: item.client_name?.company_type ?? "",
          show_company_type: item.client_name?.show_company_type
            ? companyTypeOptions?.find(
                (type) => type.value === item.client_name?.show_company_type,
              )?.label
            : "",
          start_date: convertDateToString(item.client_name?.start_date),
          registration_date: convertDateToString(
            item.client_name?.registration_date,
          ),
        },

        [fieldsDefined.client_leadership]: {
          id: item.client_leadership?.id ?? "",
          position: item.client_leadership?.position ?? "",
          worker_id: item.client_leadership?.worker_id
            ? workerOptions?.find(
                (worker) =>
                  toString(worker.value) ===
                  toString(item.client_leadership?.worker_id),
              )?.label
            : "",
          reason: item.client_leadership?.reason ?? "",
          start_date: convertDateToString(item?.client_leadership?.start_date),
          end_date: convertDateToString(item?.client_leadership?.end_date),
          effective_end_date: convertDateToString(
            item?.client_leadership?.effective_end_date,
          ),
        },
        [fieldsDefined.client_location_head_office]: {
          id: item.head_office?.id ?? "",
          location_name: item?.head_office?.location_name ?? "",
          zipcode: item?.head_office?.zipcode ?? "",
          prefecture_id: item?.head_office?.prefecture_id
            ? prefectureOptions?.find(
                (pref) => pref.value === item?.head_office?.prefecture_id,
              )?.label
            : "",
          address: item?.head_office?.address ?? "",
          apartment: item?.head_office?.apartment ?? "",
        },
        [fieldsDefined.client_location_branch_office]: {
          id: item?.branch_office?.id ?? "",
          location_name: item?.branch_office?.location_name ?? "",
          zipcode: item?.branch_office?.zipcode ?? "",
          prefecture_id: item?.branch_office?.prefecture_id
            ? prefectureOptions?.find(
                (pref) => pref.value === item?.branch_office?.prefecture_id,
              )?.label
            : "",
          address: item?.branch_office?.address ?? "",
          apartment: item?.branch_office?.apartment ?? "",
        },
        [fieldsDefined.client_location_sales_office]: {
          id: item?.sales_office?.id ?? "",
          location_name: item?.sales_office?.location_name ?? "",
          zipcode: item?.sales_office?.zipcode ?? "",
          prefecture_id: item?.sales_office?.prefecture_id
            ? prefectureOptions?.find(
                (pref) => pref.value === item?.sales_office?.prefecture_id,
              )?.label
            : "",
          address: item?.sales_office?.address ?? "",
          apartment: item?.sales_office?.apartment ?? "",
        },
        locations: item.locations || [],
      }));

    case COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key: {
      const newData = data.map((item) => {
        const newLocations =
          (item.locations as any[])?.map((loc: CompanyLocation) => ({
            ...loc,
            location_name: loc?.location_name ? loc.location_name : "未設定",
          })) || [];
        const headOfficeLocationOptions = newLocations
          ?.filter((loc) => loc.location_type === "head_office")
          .map((loc: CompanyLocation) => ({
            label: loc.location_name,
            value: loc.id,
          }));

        const branchOfficeLocationOptions = newLocations
          ?.filter((loc) => loc.location_type === "branch_office")
          .map((loc: CompanyLocation) => ({
            label: loc.location_name,
            value: loc.id,
          }));
        const salesOfficeLocationOptions = newLocations
          ?.filter((loc) => loc.location_type === "sales_office")
          .map((loc: CompanyLocation) => ({
            label: loc.location_name,
            value: loc.id,
          }));

        return {
          id: item.id ?? item?.client_id,
          [fieldsDefined.client_name]: {
            id: item.client_name?.id ?? "",
            name: item.client_name?.name ?? "",
            company_type: item.client_name?.company_type ?? "",
            show_company_type: item.client_name?.show_company_type
              ? companyTypeOptions?.find(
                  (type) => type.value === item.client_name?.show_company_type,
                )?.label
              : "",
            start_date: convertDateToString(item.client_name?.start_date),
          },
          [fieldsDefined.station_id]: item.station_id ?? "",
          [fieldsDefined.client_phone_number_head_office]: {
            id: item?.phone_number_head_office?.id ?? "",
            location_name: item?.phone_number_head_office?.location_name
              ? headOfficeLocationOptions?.find(
                  (loc) =>
                    toString(loc.label) ===
                    toString(item?.phone_number_head_office?.location_name),
                )?.label
              : "",
            fax: item?.phone_number_head_office?.fax ?? "",
            usage_memo: item?.phone_number_head_office?.usage_memo ?? "",
            contract_memo: item?.phone_number_head_office?.contract_memo ?? "",
          },
          [fieldsDefined.client_phone_number_branch_office]: {
            id: item?.phone_number_branch_office?.id ?? "",
            location_name: item?.phone_number_branch_office?.location_name
              ? branchOfficeLocationOptions?.find(
                  (loc) =>
                    toString(loc.label) ===
                    toString(item?.phone_number_branch_office?.location_name),
                )?.label
              : "",
            fax: item?.phone_number_branch_office?.fax ?? "",
            usage_memo: item?.phone_number_branch_office?.usage_memo ?? "",
            contract_memo:
              item?.phone_number_branch_office?.contract_memo ?? "",
          },
          [fieldsDefined.client_phone_number_sales_office]: {
            id: item?.phone_number_sales_office?.id ?? "",
            location_name: item?.phone_number_sales_office?.location_name
              ? salesOfficeLocationOptions?.find(
                  (loc) =>
                    toString(loc.label) ===
                    toString(item?.phone_number_sales_office?.location_name),
                )?.label
              : "",
            fax: item?.phone_number_sales_office?.fax ?? "",
            usage_memo: item?.phone_number_sales_office?.usage_memo ?? "",
            contract_memo: item?.phone_number_sales_office?.contract_memo ?? "",
          },
          [fieldsDefined.client_invoice]: {
            id: item.client_invoice?.id ?? "",
            invoice_no: item.client_invoice?.invoice_no ?? "",
          },
          [fieldsDefined.client_bank_info]: {
            id: item.client_bank_info?.id ?? "",
            bank_name:
              (item.client_bank_info as unknown as BankInfo)?.bank?.name ?? "",
            branch_name:
              (item.client_bank_info as unknown as BankInfo)?.bank?.branch ??
              "",
            bank_type: (item.client_bank_info as unknown as BankInfo)?.bank
              ?.bank_type
              ? bankTypeOptions?.find(
                  (type) =>
                    type.value ===
                    (item.client_bank_info as unknown as BankInfo)?.bank
                      ?.bank_type,
                )?.label
              : "",
            bank_number:
              (item.client_bank_info as unknown as BankInfo)?.bank
                ?.bank_number ?? "",
            trade_name:
              (item.client_bank_info as unknown as BankInfo)?.bank
                ?.trade_name ?? "",
            address:
              (item.client_bank_info as unknown as BankInfo)?.bank?.address ??
              "",
          },
          [fieldsDefined.client_registration_info]: {
            id: item.client_registration_info?.id ?? "",
            registration_name:
              item.client_registration_info?.registration_name ?? "",
            registration_code:
              item.client_registration_info?.registration_code ?? "",
            branch_code: item.client_registration_info?.branch_code ?? "",
            involved_professional:
              item.client_registration_info?.involved_professional ?? "",
            note: item.client_registration_info?.note ?? "",
          },
          locations: newLocations,
          head_office_locations: headOfficeLocationOptions || [],
          branch_office_locations: branchOfficeLocationOptions || [],
          sales_office_locations: salesOfficeLocationOptions || [],
        };
      });
      return newData;
    }

    case COMPANY_DETAIL_TABS.CONTRACT.key:
      return data.map((item) => ({
        id: item.id ?? item?.client_id,
        [fieldsDefined.client_name]: {
          id: item.client_name?.id ?? "",
          name: item.client_name?.name ?? "",
          company_type: item.client_name?.company_type ?? "",
          show_company_type: item.client_name?.show_company_type
            ? companyTypeOptions?.find(
                (type) => type.value === item.client_name?.show_company_type,
              )?.label
            : "",
          start_date: convertDateToString(item.client_name?.start_date),
        },
        [fieldsDefined.client_contract_type]: {
          id: item.client_contract_type?.id ?? "",
          category:
            item?.client_contract_type?.categories
              ?.map((c: any) => c.name)
              ?.join(",") ||
            (item?.client_contract_type?.category_ids
              ? item.client_contract_type.category_ids
                  .map(
                    (id: number) =>
                      catalogOptions?.contractTypeOptions?.find(
                        (option: any) => option.value === String(id),
                      )?.label || id,
                  )
                  .join(",")
              : item?.client_contract_type?.category
              ? (catalogOptions?.contractTypeOptions || CONTRACT_TYPE_OPTIONS)
                  ?.filter((option) =>
                    split(item?.client_contract_type?.category, ",")?.includes(
                      option.value,
                    ),
                  )
                  .map((i) => i.label)
                  .join(",")
              : ""),
          customer_number: item.client_contract_type?.customer_number ?? "",
          start_date: convertDateToString(
            item.client_contract_type?.start_date,
          ),
          end_date: convertDateToString(item.client_contract_type?.end_date),
          memo: item.client_contract_type?.memo ?? "",
        },
        [fieldsDefined.client_contract_status]: {
          id: item.client_contract_status?.id ?? "",
          status:
            item.client_contract_status?.status_option?.name ||
            (item.client_contract_status?.status_id
              ? (
                  catalogOptions?.contractStatusOptions ||
                  CONTRACT_STATUS_OPTIONS
                )?.find(
                  (option: any) =>
                    option.value ===
                    String(item.client_contract_status?.status_id),
                )?.label
              : item.client_contract_status?.status
              ? (
                  catalogOptions?.contractStatusOptions ||
                  CONTRACT_STATUS_OPTIONS
                )?.find(
                  (option) =>
                    option.value === item.client_contract_status?.status,
                )?.label
              : ""),
          staff_in_charge: item.client_contract_status?.staff_in_charge ?? "",
          start_date: convertDateToString(
            item.client_contract_status?.start_date,
          ),
          end_date: convertDateToString(item.client_contract_status?.end_date),
          memo: item.client_contract_status?.memo ?? "",
        },
      }));
    default:
      return data;
  }
};
/** Padded (YYYY年MM月DD日) and CommonDatePicker (YYYY年M月D日) cell values. */
const JP_DATE_PARSE_FORMATS = [
  DATE_TIME_FORMAT.DATE_JP_MD,
  DATE_TIME_FORMAT.DATE_JP,
];

const parseJapaneseDate = (value?: string | null) => {
  if (value === "" || value === null) return value;
  if (isUndefined(value)) return undefined;
  return toDatePickerApiDate(value) ?? undefined;
};

const parseJpSheetDate = (value?: string | null) =>
  dayjs(value, JP_DATE_PARSE_FORMATS);
const isEmptyObject = (obj: any): boolean => {
  if (typeof obj !== "object" || obj === null) return false;

  return Object.values(obj).every(
    (value) =>
      value === undefined ||
      value === null ||
      value === "" ||
      (typeof value === "object" && isEmptyObject(value)),
  );
};
export const convertPayload = (
  data: any[],
  dataValidation: any[],
  tabParams: string,
  prefectureOptions: IOptions,
  workerOptions: IOptions,
  catalogOptions?: {
    contractStatusOptions?: any[];
    contractTypeOptions?: any[];
  },
) => {
  switch (tabParams) {
    case COMPANY_DETAIL_TABS.REGISTRATION_INFO.key: {
      const dataFormatted = data.map((item) => {
        const { id, ...restItem } = item;
        const { client_leadership } =
          dataValidation?.find(
            (dataItem) =>
              dataItem.id === item.id || dataItem.rowId === item.rowId,
          ) || {};
        const result = {
          ...restItem,
          client_id: id,
          co_name: item.co_name,
          foundation_date: parseJapaneseDate(item.foundation_date),
          contract_date: parseJapaneseDate(item.contract_date),
          establishment_date: parseJapaneseDate(item.establishment_date),
          contract_cancellation_date: parseJapaneseDate(
            item.contract_cancellation_date,
          ),
          client_name: {
            ...item[fieldsDefined.client_name],
            show_company_type: item[fieldsDefined.client_name]
              ?.show_company_type
              ? companyTypeOptions?.find(
                  (type) =>
                    type.label ===
                    item[fieldsDefined.client_name]?.show_company_type,
                )?.value
              : undefined,
            start_date: parseJapaneseDate(
              item[fieldsDefined.client_name]?.start_date,
            ),
            registration_date: parseJapaneseDate(
              item[fieldsDefined.client_name]?.registration_date,
            ),
          },
          client_leadership: {
            ...item[fieldsDefined.client_leadership],
            worker_id: workerOptions?.find(
              (worker) =>
                toString(worker.label) ===
                toString(item[fieldsDefined.client_leadership]?.worker_id),
            )?.value,
            ...((item[fieldsDefined.client_leadership]?.start_date !==
              undefined ||
              item[fieldsDefined.client_leadership]?.end_date !== undefined ||
              item[fieldsDefined.client_leadership]?.effective_end_date !==
                undefined) && {
              start_date: parseJapaneseDate(client_leadership?.start_date),
              end_date: parseJapaneseDate(client_leadership?.end_date),
              effective_end_date: parseJapaneseDate(
                client_leadership?.effective_end_date,
              ),
            }),
          },
          head_office: {
            ...item[fieldsDefined.client_location_head_office],
            prefecture_id: prefectureOptions?.find(
              (pref) =>
                toString(pref.label) ===
                toString(
                  item[fieldsDefined.client_location_head_office]
                    ?.prefecture_id,
                ),
            )?.value,
          },
          branch_office: {
            ...item[fieldsDefined.client_location_branch_office],
            prefecture_id: prefectureOptions?.find(
              (pref) =>
                toString(pref.label) ===
                toString(
                  item[fieldsDefined.client_location_branch_office]
                    ?.prefecture_id,
                ),
            )?.value,
          },
          sales_office: {
            ...item[fieldsDefined.client_location_sales_office],
            prefecture_id: prefectureOptions?.find(
              (pref) =>
                toString(pref.label) ===
                toString(
                  item[fieldsDefined.client_location_sales_office]
                    ?.prefecture_id,
                ),
            )?.value,
          },
          isDelete: item.isDelete || false,
        };
        return Object.fromEntries(
          Object.entries(result).filter(([_, value]) => {
            if (value === undefined) return false;
            if (
              typeof value === "object" &&
              value !== null &&
              isEmptyObject(value)
            )
              return false;
            return true;
          }),
        );
      });
      return dataFormatted;
    }
    case COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key: {
      const dataFormatted = data.map((item) => {
        const dataLocationOptions = dataValidation?.find(
          (dataItem) =>
            dataItem.id === item.id || dataItem.rowId === item.rowId,
        )?.locations as CompanyLocation[];
        const { id, ...restItem } = item;
        const result = {
          ...restItem,
          client_id: id,
          client_name: {
            ...item[fieldsDefined.client_name],
            show_company_type: item[fieldsDefined.client_name]
              ?.show_company_type
              ? companyTypeOptions?.find(
                  (type) =>
                    type.label ===
                    item[fieldsDefined.client_name]?.show_company_type,
                )?.value
              : undefined,
            start_date: parseJapaneseDate(
              item[fieldsDefined.client_name]?.start_date,
            ),
          },
          phone_number_head_office: {
            ...item[fieldsDefined.client_phone_number_head_office],
            location_name: dataLocationOptions?.find(
              (loc) =>
                toString(loc?.location_name) ===
                toString(
                  item[fieldsDefined.client_phone_number_head_office]
                    ?.location_name,
                ),
            )?.id,
          },
          phone_number_branch_office: {
            ...item[fieldsDefined.client_phone_number_branch_office],
            location_name: dataLocationOptions?.find(
              (loc) =>
                toString(loc?.location_name) ===
                toString(
                  item[fieldsDefined.client_phone_number_branch_office]
                    ?.location_name,
                ),
            )?.id,
          },
          phone_number_sales_office: {
            ...item[fieldsDefined.client_phone_number_sales_office],
            location_name: dataLocationOptions?.find(
              (loc) =>
                toString(loc?.location_name) ===
                toString(
                  item[fieldsDefined.client_phone_number_sales_office]
                    ?.location_name,
                ),
            )?.id,
          },
          [fieldsDefined.client_bank_info]: {
            ...item[fieldsDefined.client_bank_info],
            bank_type: bankTypeOptions?.find(
              (type) =>
                toString(type.label) ===
                toString(item[fieldsDefined.client_bank_info]?.bank_type),
            )?.value,
          },
          isDelete: item.isDelete || false,
        };
        return Object.fromEntries(
          Object.entries(result).filter(([_, value]) => {
            if (value === undefined) return false;
            if (
              typeof value === "object" &&
              value !== null &&
              isEmptyObject(value)
            )
              return false;
            return true;
          }),
        );
      });
      return dataFormatted;
    }

    case COMPANY_DETAIL_TABS.CONTRACT.key: {
      const dataFormatted = data.map((item) => {
        const { id, ...restItem } = item;
        const result = {
          ...restItem,
          client_id: id,
          client_name: {
            ...item[fieldsDefined.client_name],
            show_company_type: item[fieldsDefined.client_name]
              ?.show_company_type
              ? companyTypeOptions?.find(
                  (type) =>
                    type.label ===
                    item[fieldsDefined.client_name]?.show_company_type,
                )?.value
              : undefined,
            start_date: parseJapaneseDate(
              item[fieldsDefined.client_name]?.start_date,
            ),
          },
          [fieldsDefined.client_contract_status]: {
            ...omit(item[fieldsDefined.client_contract_status], "status"),
            id: item[fieldsDefined.client_contract_status]?.id
              ? String(item[fieldsDefined.client_contract_status]?.id)
              : undefined,
            status_id: (() => {
              const statusVal =
                item[fieldsDefined.client_contract_status]?.status;
              if (!statusVal) return undefined;
              const found =
                catalogOptions?.contractStatusOptions?.find(
                  (option: any) =>
                    option.label === statusVal || option.value === statusVal,
                ) ||
                CONTRACT_STATUS_OPTIONS.find(
                  (option) =>
                    option.label === statusVal || option.value === statusVal,
                );
              return found && !Number.isNaN(Number(found.value))
                ? Number(found.value)
                : undefined;
            })(),
            start_date: parseJapaneseDate(
              item[fieldsDefined.client_contract_status]?.start_date,
            ),
            end_date: parseJapaneseDate(
              item[fieldsDefined.client_contract_status]?.end_date,
            ),
          },
          [fieldsDefined.client_contract_type]: {
            ...omit(item[fieldsDefined.client_contract_type], "category"),
            id: item[fieldsDefined.client_contract_type]?.id
              ? String(item[fieldsDefined.client_contract_type]?.id)
              : undefined,
            category_ids: (() => {
              const catVal = item[fieldsDefined.client_contract_type]?.category;
              if (!catVal) return undefined;
              const rawItems = Array.isArray(catVal)
                ? catVal
                : split(catVal, ",");
              const ids = rawItems
                .map((itemStr: string) => {
                  const trimmed = itemStr.trim();
                  const found =
                    catalogOptions?.contractTypeOptions?.find(
                      (option: any) =>
                        option.label === trimmed || option.value === trimmed,
                    ) ||
                    CONTRACT_TYPE_OPTIONS.find(
                      (option) =>
                        option.label === trimmed || option.value === trimmed,
                    );
                  return found ? Number(found.value) : Number(trimmed);
                })
                .filter((numId) => !Number.isNaN(numId));
              return ids.length > 0 ? ids : undefined;
            })(),
            start_date: parseJapaneseDate(
              item[fieldsDefined.client_contract_type]?.start_date,
            ),
            end_date: parseJapaneseDate(
              item[fieldsDefined.client_contract_type]?.end_date,
            ),
          },
          isDelete: item.isDelete || false,
        };
        return Object.fromEntries(
          Object.entries(result).filter(([_, value]) => {
            if (value === undefined) return false;
            if (
              typeof value === "object" &&
              value !== null &&
              isEmptyObject(value)
            )
              return false;
            return true;
          }),
        );
      });
      return dataFormatted;
    }

    default:
      return data;
  }
};

export const getNestedObjectId = (obj: any, basePath: string) => {
  const nestedObj = get(obj, basePath);
  return nestedObj?.id;
};

export const tabParamSaveEnums = {
  [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: "save_tab1",
  [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: "save_tab2",
  [COMPANY_DETAIL_TABS.CONTRACT.key]: "save_tab3",
};

type ValidationResult = {
  hasError: boolean;
  errorMessage: string;
  errorCount?: number;
};

export const validateRowData = (
  dataItem: any,
  filterFields: string[],
  requiredFields: string[],
): ValidationResult => {
  const { haveData } = checkSheetInvalid(dataItem, filterFields as string[]);

  if (!haveData && !dataItem.id) {
    return { hasError: false, errorMessage: "", errorCount: 0 };
  }

  const errorMessages: string[] = [];
  const errorFields: string[] = [];

  // Check required fields
  for (const field of requiredFields) {
    const fieldValue = get(dataItem, field);
    if (checkInvalidValue(fieldValue)) {
      errorFields.push(field);
    }
  }

  if (errorFields.length > 0) {
    errorMessages.push("必須項目を入力してください。");
  }

  // Check zipcode format
  const zipcodeFields = [
    fieldsDefined.client_location_head_office_zipcode,
    fieldsDefined.client_location_branch_office_zipcode,
    fieldsDefined.client_location_sales_office_zipcode,
  ];

  for (const field of zipcodeFields) {
    const value = get(dataItem, field);
    if (value && String(value).replace(/-/g, "")?.length !== 7) {
      errorMessages.push("郵便番号は7桁で入力してください。");
      break;
    }
  }

  // Check co_number format
  const coNumber = get(dataItem, fieldsDefined.co_number);
  if (coNumber && String(coNumber).length !== 13) {
    errorMessages.push("13桁すべてを入力してください。");
  }

  // Check date ranges
  const dateRangeChecks = [
    {
      startField: fieldsDefined.client_name_start_date,
      endField: fieldsDefined.client_name_registration_date,
    },
    {
      startField: fieldsDefined.client_contract_type_start_date,
      endField: fieldsDefined.client_contract_type_end_date,
    },
    {
      startField: fieldsDefined.client_contract_status_start_date,
      endField: fieldsDefined.client_contract_status_end_date,
    },
    {
      startField: fieldsDefined.contract_date,
      endField: fieldsDefined.contract_cancellation_date,
    },
  ];

  for (const { startField, endField } of dateRangeChecks) {
    const startDate = get(dataItem, startField);
    const endDate = get(dataItem, endField);
    const errorMsg = "終了日は開始日より後でなければなりません。";

    if (startDate && endDate) {
      const startParsed = parseJpSheetDate(startDate);
      const endParsed = parseJpSheetDate(endDate);

      if (
        startParsed.isValid() &&
        endParsed.isValid() &&
        !endParsed.isAfter(startParsed)
      ) {
        errorMessages.push(errorMsg);
      }
    }
  }

  // Check leadership dates
  const leadershipStartDate = get(
    dataItem,
    fieldsDefined.client_leadership_start_date,
  );
  const leadershipEffectiveEndDate = get(
    dataItem,
    fieldsDefined.client_leadership_effective_end_date,
  );
  const leadershipEndDate = get(
    dataItem,
    fieldsDefined.client_leadership_end_date,
  );

  if (leadershipStartDate || leadershipEffectiveEndDate || leadershipEndDate) {
    const startParsed = parseJpSheetDate(leadershipStartDate);
    const effectiveEndParsed = parseJpSheetDate(leadershipEffectiveEndDate);
    const endParsed = parseJpSheetDate(leadershipEndDate);

    // startDate < effectiveEndDate
    if (
      leadershipStartDate &&
      leadershipEffectiveEndDate &&
      startParsed.isValid() &&
      effectiveEndParsed.isValid() &&
      !effectiveEndParsed.isAfter(startParsed)
    ) {
      errorMessages.push(
        "代表者の開始日は有効終了日より前である必要があります。",
      );
    }

    // startDate < endDate
    if (
      leadershipStartDate &&
      leadershipEndDate &&
      startParsed.isValid() &&
      endParsed.isValid() &&
      !endParsed.isAfter(startParsed)
    ) {
      errorMessages.push("代表者の開始日は終了日より前である必要があります。");
    }

    // endDate >= effectiveEndDate
    if (
      leadershipEndDate &&
      leadershipEffectiveEndDate &&
      effectiveEndParsed.isValid() &&
      endParsed.isValid() &&
      endParsed.isBefore(effectiveEndParsed)
    ) {
      errorMessages.push(
        "代表者の終了日は有効終了日以降である必要があります。",
      );
    }
  }

  if (errorMessages.length === 0) {
    return { hasError: false, errorMessage: "", errorCount: 0 };
  }

  const uniqueErrors = Array.from(new Set(errorMessages));
  let finalMessage = "";

  if (uniqueErrors.length >= 2) {
    finalMessage = "必須項目を入力してください。";
  } else {
    finalMessage = uniqueErrors[0];
  }

  return {
    hasError: true,
    errorMessage: finalMessage,
    errorCount: uniqueErrors.length,
  };
};

export const mergeNestedIds = (currentData: any, responseData: any): any => {
  if (!currentData || !responseData) return currentData ?? {};

  const merged = cloneDeep(currentData);

  Object.keys(responseData).forEach((key) => {
    if (key === "client_id") return;

    const responseValue = responseData[key];

    if (
      responseValue !== null &&
      typeof responseValue === "object" &&
      !Array.isArray(responseValue) &&
      "id" in responseValue
    ) {
      if (merged[key] && typeof merged[key] === "object") {
        merged[key] = {
          ...merged[key],
          id: responseValue.id,
        };
      } else {
        merged[key] = { id: responseValue.id };
      }
    }
  });

  return merged;
};
